import { render } from "./tiendas.vue?vue&type=template&id=6c9db131&scoped=true"
import script from "./tiendas.vue?vue&type=script&lang=js"
export * from "./tiendas.vue?vue&type=script&lang=js"

import "./tiendas.vue?vue&type=style&index=0&id=6c9db131&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6c9db131"]])

export default __exports__